<!-- ==============================
     LANDING PAGE - Guest View
     ============================== -->

<!-- ===== SECTION 1: HERO (same as company-home) ===== -->
<section class="hero-container" id="home">
  <!-- Same background image as company home -->
  <img class="hero-bg-img" src="assets/img/hero-img.webp" alt="hero background" />

  <!-- Content overlay - CENTERED -->
  <div class="hero-overlay-content">
    <!-- Decorative shooting-star dash -->
    <div class="hero-dash"></div>

    <h1 class="hero-title">
      {{ "landing.heroTitle" | translate }}
    </h1>
    <p class="hero-subtitle">
      {{ "landing.heroSubtitle" | translate }}
    </p>

    <!-- Two CTA Buttons side by side -->
    <div class="hero-buttons-row">
      <!-- Job Seeker Button -->
      <button class="btn-hero btn-seeker" (click)="navigateTo('/home')">
        <span class="btn-label">{{ "landing.continueSeeker" | translate }}</span>
        <span class="btn-arrow-circle">
          <i class="bi bi-arrow-up-right"></i>
        </span>
      </button>

      <!-- Company Button -->
      <button class="btn-hero btn-company" (click)="navigateTo('/company-home')">
        <span class="btn-label">{{ "landing.continueCompany" | translate }}</span>
        <span class="btn-arrow-circle">
          <i class="bi bi-arrow-up-right"></i>
        </span>
      </button>
    </div>

    <!-- Trust Badge -->
    <div class="trusted-badge">
      <div class="avatar-group">
        <div class="av av1"><i class="bi bi-person-fill"></i></div>
        <div class="av av2"><i class="bi bi-person-fill"></i></div>
        <div class="av av3"><i class="bi bi-person-fill"></i></div>
        <div class="av av4"><i class="bi bi-person-fill"></i></div>
      </div>
      <span class="trusted-text">
        {{ "landing.trusted" | translate:{ count: 1200 } }}
      </span>
    </div>
  </div>
</section>


<!-- ===== SECTION 2: ONE PLACE ===== -->
<section class="one-place-section">
  <div class="one-place-container">
    
    <!-- Left: Image (shapes are already inside the image) -->
    <div class="one-place-visual">
      <img src="assets/img/company/Frame 2095588647 (1).png" alt="career professional pointing" class="op-person-img" />
    </div>

    <!-- Right: Text content -->
    <div class="one-place-content">
      <h2 class="section-title">{{ "landing.onePlaceTitle" | translate }}</h2>
      <p class="section-description">
        {{ "landing.onePlaceDesc" | translate }}
      </p>
    </div>
  </div>
</section>

<!-- ===== SECTION 3: FOR JOB SEEKERS ===== -->
<section class="seekers-section">
  <div class="seekers-container">
    <!-- Left: Text -->
    <div class="seekers-text">
      <span class="seekers-tag">{{ "landing.forSeekers" | translate }}</span>
      <h2 class="seekers-title">
        {{ "landing.seekersTitle" | translate }}
      </h2>
      <p class="seekers-desc">
        {{ "landing.seekersDesc" | translate }}
      </p>

      <ul class="seekers-list">
        <li class="seekers-list-item">
          <span class="seekers-dot"></span>
          {{ "landing.seekersItem1" | translate }}
        </li>
        <li class="seekers-list-item">
          <span class="seekers-dot"></span>
          {{ "landing.seekersItem2" | translate }}
        </li>
        <li class="seekers-list-item">
          <span class="seekers-dot"></span>
          {{ "landing.seekersItem3" | translate }}
        </li>
      </ul>

      <button class="seekers-btn" (click)="navigateTo('/home')">
        {{ "landing.exploreSeekers" | translate }}
        <span class="cta-arrow" aria-hidden="true">→</span>
      </button>
    </div>

    <!-- Right: Container image -->
    <div class="seekers-image">
      <img src="assets/img/company/Container.png" alt="Job seeker dashboard" class="seekers-img" />
    </div>
  </div>
</section>

<!-- ===== SECTION 4: FOR COMPANIES ===== -->
<section class="companies-section">
  <div class="companies-container">

    <!-- Left: Container image -->
    <div class="companies-image">
      <img src="assets/img/company/Container (1).png" alt="Company hiring dashboard" class="companies-img" />
    </div>

    <!-- Right: Text -->
    <div class="companies-text">
      <span class="companies-tag">{{ "landing.forCompanies" | translate }}</span>
      <h2 class="companies-title">
        {{ "landing.companiesTitle" | translate }}
      </h2>
      <p class="companies-desc">
        {{ "landing.companiesDesc" | translate }}
      </p>

      <ul class="companies-list">
        <li class="companies-list-item">
          <span class="companies-dot"></span>
          {{ "landing.companiesItem1" | translate }}
        </li>
        <li class="companies-list-item">
          <span class="companies-dot"></span>
          {{ "landing.companiesItem2" | translate }}
        </li>
      </ul>

      <button class="companies-btn" (click)="navigateTo('/company-home')">
        {{ "landing.exploreCompanies" | translate }}
        <span class="cta-arrow" aria-hidden="true">→</span>
      </button>
    </div>

  </div>
</section>

<!-- ===== SECTION 5: CHOOSE YOUR PATH ===== -->
<section class="choose-section">
  <h2 class="choose-title">{{ "landing.chooseTitle" | translate }}</h2>

  <div class="choose-cards">
    <!-- Job Seeker Card -->
    <div class="choose-card seeker-card" (click)="navigateTo('/home')">
      <span class="choose-card-tag">{{ "landing.jobSeeker" | translate }}</span>
      <h3 class="choose-card-title">{{ "landing.growCareer" | translate }}</h3>
      <button class="choose-card-btn">
        {{ "landing.continueSeeker" | translate }}
        <svg class="cta-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </button>
    </div>

    <!-- Company Card -->
    <div class="choose-card company-card" (click)="navigateTo('/company-home')">
      <span class="choose-card-tag">{{ "landing.company" | translate }}</span>
      <h3 class="choose-card-title">{{ "landing.lookingToHire" | translate }}</h3>
      <button class="choose-card-btn">
        {{ "landing.continueCompany" | translate }}
        <svg class="cta-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </button>
    </div>
  </div>
</section>
